/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WixxGameModuleConfig} from "./WixxGameModuleConfig";
import {BackgroundParticles} from "./particles/BackgroundParticles";
import {WixxWinCountUp} from "./winpresentation/countup/WixxWinCountUp";

export class Wixx extends SlotGame {

    public static particles:BackgroundParticles;
    public static winCountUp:WixxWinCountUp;

    constructor() {
        super(WixxGameModuleConfig.instance);
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L4",
                    "L4",
                    "M1",
                    "L2",
                    "L2"
                ],
                [
                    "L3",
                    "L3",
                    "L3",
                    "M2",
                    "L1"
                ],
                [
                    "L3",
                    "L3",
                    "L3",
                    "L1",
                    "L1"
                ],
                [
                    "L1",
                    "L1",
                    "L1",
                    "M3",
                    "L4"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 2,
            "boosterSpinTriggered": false,
            "stackedReelFourRespinTriggered": false,
            "symbolToWildRespinTriggered": false,
            "multiplierRespinTriggered": false,
            "stackedReelFourRespinActive": false,
            "symbolToWildRespinActive": false,
            "multiplierRespinActive": false,
            "nearWinReels": [
                false,
                false,
                false,
                false
            ],
            "excitementPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "stackedSymbolAttention": [
                false,
                false,
                false,
                false
            ],
            "wildHighlight": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "superBoosterExcitement": false,
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL"
        };
    }
}